import { motion } from "framer-motion";
import { ARTIST_PORTRAIT } from "@/data/artworks";

export const AboutSection = () => (
  <section id="about" className="px-6 py-24 lg:px-16 lg:py-36">
    <div className="grid grid-cols-12 gap-x-4 gap-y-10 lg:gap-20">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="col-span-12 lg:col-span-5"
      >
        <div className="relative overflow-hidden border border-black/10">
          <img
            src={ARTIST_PORTRAIT}
            alt="Portrait of Roy A Smith"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10%" }}
        transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        className="col-span-12 flex flex-col justify-center lg:col-span-7"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.5em] text-[#9A7B24]">About</p>
        <h2 className="font-display mt-4 text-3xl font-light tracking-tight text-[#131311] sm:text-4xl lg:text-5xl">
          “I live my life in passionate
          <br />
          service to <em className="text-[#B08D2E]">Jesus Christ</em>
          <br />
          my Lord and Savior.”
        </h2>
        <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-zinc-600">
          Roy A Smith is a serial entrepreneur who builds companies that challenge how things have
          always been done. Every venture starts with the same question — what if this industry
          worked differently? — and ends with something that did not exist before.
        </p>
        <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-zinc-500">
          This collection is private by design. If you hold a card, you were meant to be here.
        </p>

        <div className="mt-12">
          <span className="font-display text-4xl font-light italic text-zinc-700">Roy A Smith</span>
          <svg viewBox="0 0 220 12" className="mt-1 w-52 text-[#B08D2E]">
            <motion.path
              d="M4 8 C 60 2, 150 2, 216 7"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              initial={{ pathLength: 0 }}
              whileInView={{ pathLength: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: "easeInOut" }}
            />
          </svg>
        </div>
      </motion.div>
    </div>
  </section>
);
